import { Component, inject } from '@angular/core';
import { LucideAngularModule, CheckCircle2, AlertTriangle, Info, XCircle, X } from 'lucide-angular';
import { NotificationService, NotificationType } from '../../../core/services/notification.service';

/**
 * Host global de notificaciones (toasts). Se monta una sola vez en `app.component` y
 * renderiza la cola de {@link NotificationService}. Los demás componentes no lo usan
 * directamente: emiten toasts llamando a `NotificationService.success/error/info/...`.
 */
@Component({
  selector: 'app-toast-host',
  standalone: true,
  imports: [LucideAngularModule],
  templateUrl: './toast-host.component.html',
  styleUrl: './toast-host.component.scss',
})
export class ToastHostComponent {
  private readonly service = inject(NotificationService);
  readonly notifications = this.service.notifications;

  private readonly icons: Record<NotificationType, any> = {
    success: CheckCircle2,
    error: XCircle,
    warning: AlertTriangle,
    info: Info,
  };
  readonly closeIcon = X;

  iconFor(type: NotificationType) {
    return this.icons[type];
  }

  dismiss(id: number): void {
    this.service.dismiss(id);
  }
}
